import { render, staticRenderFns } from "./EditPillarGroup.vue?vue&type=template&id=e92322c4"
import script from "./EditPillarGroup.vue?vue&type=script&lang=js"
export * from "./EditPillarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports